/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Entity_DocumentInputs */

const cs_enum_entity_document = /** @type {(inputs: Enum_Entity_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument`)
};

const en_enum_entity_document = /** @type {(inputs: Enum_Entity_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document`)
};

/**
* | output |
* | --- |
* | "Document" |
*
* @param {Enum_Entity_DocumentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_entity_document = /** @type {((inputs?: Enum_Entity_DocumentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Entity_DocumentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_entity_document(inputs)
	return cs_enum_entity_document(inputs)
});